import React from "react";

function EmptyTodos() {
  return <p>¡Create your first TODO!</p>;
}

export { EmptyTodos };
